import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'WYSIWYGTagFilter' })
export class FilterAllowedWYSIWYGTagsPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string | undefined): SafeHtml {
    if (!value) {
      return '';
    }

    const allowed = [
      'p',
      'br',
      'hr',
      'span',
      'ul',
      'ol',
      'li',
      'a',
      'b',
      'u',
      'i',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'em',
      'strong',
    ];
    const allowedTagsPattern = allowed.join('|');

    const regex = new RegExp(`<(?!/?(?:${allowedTagsPattern})\\b)[^>]*>`, 'gi');

    return this.sanitized.bypassSecurityTrustHtml(value.replace(regex, ''));
  }
}
